import { combineReducers } from '@reduxjs/toolkit';
import resourceSlice from './resource.slice';
import resourceCategorySlice from './resourceCategory.slice';

export const resourceRootReducer = combineReducers({
    resource: resourceSlice,
    resourceCategory: resourceCategorySlice,
});
